import { render, staticRenderFns } from "./PermitCustomer.vue?vue&type=template&id=b73e92b4"
import script from "./PermitCustomer.vue?vue&type=script&lang=js"
export * from "./PermitCustomer.vue?vue&type=script&lang=js"
import style0 from "./PermitCustomer.vue?vue&type=style&index=0&id=b73e92b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports